// This icon file is generated automatically.
var PNameOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.13 12.06H1.87a.13.13 0 00-.12.13v.94c0 .06.06.12.13.12h10.25c.06 0 .12-.06.12-.13v-.93a.13.13 0 00-.13-.13zm0-11.31H1.87a.13.13 0 00-.12.13v.93c0 .07.06.13.13.13h10.25c.06 0 .12-.06.12-.13V.87a.13.13 0 00-.13-.12zM8.54 4.91c.1 0 .15-.11.1-.19L7.05 2.73a.11.11 0 00-.18 0l-1.57 2c-.06.07-.01.18.09.18h1.04v4.18h-.98c-.1 0-.15.11-.1.19l1.58 1.99c.05.06.13.06.18 0l1.57-2a.11.11 0 00-.09-.18H7.56V4.91h.98z", "fill-rule": "nonzero" } }] }, "name": "p-name", "theme": "outlined" };
export default PNameOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PNameOutlined.js
// module id = 3523
// module chunks = 0